var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pc-view-holder"},[_c('Header'),_c('main',{staticClass:"pc-main"},[(_vm.baseInfoLoading)?_c('PcPageLoading',{attrs:{"text":"页面初始化中..."}}):_vm._e(),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }